// extracted by mini-css-extract-plugin
module.exports = {"CustomOverlay":"CustomWithSpinner_CustomOverlay__3wNsx","SpinnerContainer":"CustomWithSpinner_SpinnerContainer__1T9Wh"};